import { useState } from 'react';
import IconSuccess16 from '@warp-ds/icons/react/success-16';
import { useSidebarContext } from '../../state/SidebarContext';
import { SuggestShippingActionType, SuggestShippingType } from '../../types/uiTypes';
import ContactButton from '../ContactButton';
import MakeSuggestion from './SuggestShipping/MakeSuggestion';
import TradeTypeAndPrice from './TradeTypeAndPrice';
import FiksFerdigHelperText from './SuggestShipping/FiksFerdigHelperText';

const NotOptedIn = () => {
    const { uiText } = useSidebarContext();
    const { suggestShipping, notOptedIn } = uiText.sections.sidebar;

    // Used for the suggest experiment
    const [suggestionMadeText, setSuggestionMadeText] = useState<SuggestShippingType | undefined>();
    const canAskForFiksFerdig = suggestShipping?.actions
        ?.suggestShipping as SuggestShippingActionType;
    const hasAskedForFiksFerdig =
        uiText.context?.suggestionStatus === 'SHIPPING_ALREADY_SUGGESTED' || !!suggestionMadeText;
    const isElibleForFiksFerdig = canAskForFiksFerdig || hasAskedForFiksFerdig;
    return (
        <>
            <TradeTypeAndPrice uiText={notOptedIn} />
            <section className="flex flex-col gap-12">
                <ContactButton />
                {isElibleForFiksFerdig ? (
                    <>
                        {hasAskedForFiksFerdig ? (
                            <div className="flex items-center w-full justify-center">
                                <IconSuccess16 className="s-icon-positive" />
                                <div className="ml-8 mt-8">
                                    <p>
                                        {suggestionMadeText?.title ??
                                            uiText.sections.sidebar?.suggestShipping?.title}
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <MakeSuggestion
                                updateUiText={setSuggestionMadeText}
                                uiText={suggestShipping.actions.suggestShipping}
                            />
                        )}
                    </>
                ) : null}
            </section>

            {/* Only show description about fiks ferdig if user is able to ask for it */}
            {isElibleForFiksFerdig ? (
                <FiksFerdigHelperText
                    hasAskedForFiksFerdig={hasAskedForFiksFerdig}
                    suggestionMadeText={suggestionMadeText}
                />
            ) : null}
        </>
    );
};

export default NotOptedIn;
